import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/shared/hooks/use-toast';
import { useI18n } from '@/contexts/I18nContext';

interface DeletePostParams {
  postId: string;
  reason: string;
}

export const useAdminDeletePost = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useI18n();

  return useMutation({
    mutationFn: async ({ postId, reason }: DeletePostParams) => {
      const { data, error } = await supabase.functions.invoke('admin-delete-post', {
        body: { post_id: postId, reason }
      });

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      // Invalidate and refetch posts
      queryClient.invalidateQueries({ queryKey: ['posts'] });
      queryClient.invalidateQueries({ queryKey: ['social-feed'] });
      
      toast({
        title: t('notifications.toasts.admin_post_deleted'),
        description: t('notifications.toasts.admin_post_deleted_description'),
      });
    },
    onError: (error: any) => {
      console.error('Error deleting post:', error);
      toast({
        title: t('notifications.toasts.admin_error_deleting_post'),
        description: error.message || t('notifications.toasts.admin_error_deleting_post_description'),
        variant: "destructive",
      });
    },
  });
};

